const initialState = {
  ranges: [],
  loading: false,
  error: null,
};

const rangeReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "FETCH_RANGES_LOADING":
      return { ...state, loading: true, error: null };
    case "FETCH_RANGES_SUCCESS":
      return { ...state, loading: false, ranges: payload, error: null };
    case "FETCH_RANGES_ERROR":
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};

export default rangeReducer;
